export default "__VITE_ASSET__DJeHhA2j__"